import {addSeconds} from 'date-fns';
import HumanReadableTime from '../models/HumanReadableTime';
import {Runner} from '../models/runner';
import {RUNS_HUMAN_READABLE} from '../models/waypoint';
import RunProvider from './run';
import RenderProvider from './render';

export default class RunnerCountdown {
    static instance = null;

    private secondsInterval: ReturnType<typeof setInterval>;

    private timeUntilPlannedStart: HumanReadableTime = new HumanReadableTime(0);

    private runProvider: RunProvider;

    private renderProvider: RenderProvider;

    private runner: Runner;

    static getInstance(): RunnerCountdown {
        if (!this.instance) {
            this.instance = new RunnerCountdown();
        }

        return this.instance;
    }

    constructor() {
        this.runProvider = RunProvider.getInstance();
        this.renderProvider = RenderProvider.getInstance();
    }

    subscribe(runner: Runner) {
        if (this.secondsInterval) {
            clearInterval(this.secondsInterval);
        }

        this.runner = runner;

        if (this.runner.hasStarted()) {
            this.renderProvider.runnerCountdown.classList.add('hidden');
            this.renderProvider.runnerCountdownDays.parentElement.classList.add('hidden');
            return;
        }

        this.renderProvider.runnerCountdown.classList.remove('hidden');
        this.renderProvider.runnerCountdownDays.parentElement.classList.remove('hidden');

        this.updateSeconds();

        const humanReadableRun = this.runProvider.translate(RUNS_HUMAN_READABLE[this.runner.run]);
        this.renderProvider.runnerCountdownHeadline.innerHTML = this.timeUntilPlannedStart.days > 1 ? (
            this.runProvider.translate('Der %s startet in:', humanReadableRun)
        ) : this.runProvider.translate('Aufgepasst! Es geht los in:');

        this.secondsInterval = setInterval(() => this.updateSeconds(), 1000);
    }

    unsubscribe() {
        this.renderProvider.runnerCountdown.classList.add('hidden');
        this.runner = null;

        clearInterval(this.secondsInterval);
    }

    updateSeconds() {
        if (!this.runner || this.runner.hasStarted()) {
            this.unsubscribe();
            return;
        }

        this.timeUntilPlannedStart = this.runProvider.getTimeUntilRun(this.runner);

        const {
            days,
            hours,
            minutes,
            seconds,
        } = this.timeUntilPlannedStart;

        this.renderProvider.runnerCountdownDays.innerHTML = RunnerCountdown.leadingZero(days);
        this.renderProvider.runnerCountdownHours.innerHTML = RunnerCountdown.leadingZero(hours);
        this.renderProvider.runnerCountdownMins.innerHTML = RunnerCountdown.leadingZero(minutes);
        this.renderProvider.runnerCountdownSecs.innerHTML = RunnerCountdown.leadingZero(seconds);

        if (this.timeUntilPlannedStart.days < 1) {
            this.renderProvider.runnerCountdownDays.parentElement.classList.add('hidden');
            this.renderProvider.runnerCountdownSecs.parentElement.classList.remove('hidden');
        }

        if (days === 1) {
            const daysLabel = this.renderProvider.runnerCountdownDays.nextSibling as HTMLElement;
            daysLabel.innerText = this.runProvider.translate('Tag');
        }

        if (this.timeUntilPlannedStart.time <= 0) {
            this.renderProvider.runnerCountdown.innerHTML = this.runProvider.translate('Daten werden geladen…');
        }
    }

    static leadingZero(value: number): string {
        return value < 10 ? `0${value}` : value.toString();
    }
}
